import type { ZebraDpi } from "../types/render";

export function dotsPerMm(dpi: ZebraDpi): number {
  return dpi === 300 ? 12 : 8;
}

export function mmToSignedDots(mm: number, dpi: ZebraDpi): number {
  return Math.round(mm * dotsPerMm(dpi));
}

export function mmToDots(mm: number, dpi: ZebraDpi): number {
  return Math.max(0, mmToSignedDots(mm, dpi));
}

export function roundMm(mm: number): number {
  return Math.round(mm * 1000) / 1000;
}
